import React from 'react';
import PortalInfo from '../sections/portalInfo';
import InviteUsers from './inviteUsers';
import Attribution from '../features';

export const createSections = (portal, updatePortal, reloadCallback) => {
  const sections = [
    {
      title: 'Settings',
      description: `Creating a Portal`,
      content: (
        <PortalInfo
          portal={portal}
          onChange={portalInfo => updatePortal({ ...portal, ...portalInfo })}
          reloadCallback={reloadCallback}
          isCreateMode={true}
        />
      ),
      required: true,
      validation: () => {
        return portal.displayName && portal.displayName.length >= 4;
      }
    },
    {
      title: `Invite Brand users`,
      description: `Invite Brand users to the Portal.`,
      content: <InviteUsers portal={portal} onChangeCB={users => updatePortal({ ...portal, users })} />,
      required: false,
      modified: () => (portal.users !== undefined ? portal.users.length !== 0 : false)
    },
    {
      title: `Attribution`,
      description: `Activate Attribution in the Portal.`,
      content: (
        <Attribution attributions={portal.features} onSelection={features => updatePortal({ ...portal, features })} />
      ),
      required: false,
      modified: () => (portal.features !== undefined ? portal.features.length !== 0 : false)
    }
  ];

  return sections;
};
